import React from 'react';
import Spinner from '../../Spinner';
import './SpinnerStyle.scss';
function SpinnerStyle(props) {
    return (React.createElement("div", { className: "elmo-spinner-container" },
        React.createElement(Spinner, null)));
}
export default SpinnerStyle;
